import TemplateView from "./TemplateView";

export default class CustomCheckbox extends TemplateView
{
    constructor($containerEl)
    {
        super($containerEl);
        this.checked = false;
    }

    afterRender()
    {
        this.bindClick(() => this.setChecked(!this.checked));
    }

    update()
    {
        this.$el.toggleClass("checked", this.checked);
    }

    isChecked()
    {
        return this.checked;
    }

    setChecked(checked)
    {
        if (this.checked !== checked)
        {
            this.checked = checked;
            this.update();
            this.trigger("check", this.checked);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/CustomCheckbox.js